import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getProductDetail, createProduct, getBestSellerProduct, getScreensaverData } from '../../actions/customizer';
import { RootState } from '../../store';
import { AnyObject } from '../../../utils/basic';

export interface CustomizerState {
  isFetching: boolean;
  product?: any;
  createdProduct: null | AnyObject;
  bestSellerProduct: null | AnyObject;
  screensaverData: null | AnyObject;
}

const initialState: CustomizerState = {
  isFetching: false,
  product: undefined,
  createdProduct: null,
  bestSellerProduct: null,
  screensaverData: null
};

export const customizerSlice = createSlice({
  name: 'customizer',
  initialState: initialState,
  reducers: {
    setProductData: (state: CustomizerState, action: PayloadAction<object>) => {
      state.product = action.payload;
    },
    resetCreatedProduct: (state: CustomizerState) => {
      state.createdProduct = null;
    },
    setBestSellerProduct: (state: CustomizerState, action: PayloadAction<object>) => {
      state.bestSellerProduct = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductDetail.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getProductDetail.fulfilled, (state, action) => {
        state.isFetching = false;
        state.product = action.payload;
      })
      .addCase(getProductDetail.rejected, (state) => {
        state.isFetching = false;
      })
      .addCase(createProduct.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.isFetching = false;
        state.createdProduct = action.payload;
      })
      .addCase(createProduct.rejected, (state) => {
        state.isFetching = false;
      })
      .addCase(getBestSellerProduct.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getBestSellerProduct.fulfilled, (state, action) => {
        state.isFetching = false;
        state.bestSellerProduct = action.payload;
      })
      .addCase(getBestSellerProduct.rejected, (state) => {
        state.isFetching = false;
      })
      .addCase(getScreensaverData.fulfilled, (state, action) => {
        state.screensaverData = action.payload;
      })
      .addCase(getScreensaverData.rejected, (state) => {
        state.screensaverData = null;
      });
  }
});

export const { setProductData, resetCreatedProduct } = customizerSlice.actions;

const customizerReducer = customizerSlice.reducer;

export const selectProduct = (state: RootState) => {
  return state.customizer.product;
};

export const selectCreatedProduct = (state: RootState) => {
  return state.customizer.createdProduct;
};

export default customizerReducer;
